import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {AuthLayoutComponent} from './layout/auth-layout/auth-layout.component';
import {FullLayoutComponent} from './layout/full-layout/full-layout.component';
import {PageNotFoundComponent} from '@shared/components/page-not-found/page-not-found.component';
import {SingleLayoutComponent} from './layout/single-layout/single-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () => import('@modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'ai-training',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/ai-training/ai-training.module').then(m => m.AiTrainingModule)
  },
  {
    path: 'ai-data-center',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/data-center/data-center.module').then(m => m.DataCenterModule)
  },
  {
    path: 'simulation-hub',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/simulation-center/simulation-center.module').then(m => m.SimulationCenterModule)
  },
  {
    path: 'view-simulated-data',
    component: SingleLayoutComponent,
    loadChildren: () => import('@modules/view-simulated-data/view-simulated-data.module').then(m => m.ViewSimulatedDataModule)
  },
  {
    path: 'app-manager',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/app-manager/app-manager.module').then(m => m.AppManagerModule)
  },
  {
    path: 'settings',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: '404',
    component: FullLayoutComponent,
    children: [
      {
        path: '',
        component: PageNotFoundComponent
      }
    ]
  },
  {path: '**', redirectTo: '404'}
];

const config: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
  initialNavigation: 'enabledNonBlocking'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
